<template>
  <rs-container  style="height: 100%" >
    <div v-if="maskFlag" class="msgDivImg"></div>
    <rs-header class="main_header" style="height: 52px; background: #1d3262">
      <p class="header_title">
        <span class="logo" style="width:500px">
          <!-- <img :src="imgForm.customIndexLogo"/> -->
          <img style="width: 100%" src="../../assets/images/paylogo.png" />
          <!-- <p>{{ imgForm.customIndexTitle }}</p> -->
        </span>
        <!-- <span
          v-viewButton
          v-html="!isCollapse ? '&#xe77b;' : '&#xe77a;'"
          class="font_family menuShouqi"
          @click="isCollapse = !isCollapse"
        ></span> -->
      </p>
      <div class="button_block" v-viewButton>
        <div class="Title" style="">
			<!-- <el-tag 
			            closable 
			            size="medium" 
			            v-for="(tag,index) in tags" 
			            :key="tag.name" 
			            :disable-transitions="true"
			            :effect="$route.path === tag.url ?'dark':'plain'" 
			            @close="handleClose(tag,index)" 
			            @click="handleClick(tag)">
			                {{tag.name}}
			        </el-tag> -->
			
		<!-- 	<rs-menu
			          
			          class="el-menu-demo"
			          mode="horizontal"
			          background-color="rgba(0,0,0,0)"
			          text-color="rgba(255, 255, 255, 0.6)"
			          active-text-color="#203dff"
			          @select="handleSelect"
			          router
			        >
			         
			          <template v-for="(item, index) in texts">
			            <template>
			              <rs-menu-item :index="item.index" :key="index">
			                <template slot="title">
			                  <span slot="title">{{ item.text }}</span>
			                </template>
			              </rs-menu-item>
			            </template>
			          </template>
			        </rs-menu> -->
         <!-- <ul>
            <li
			id="li"
              v-for="(item, index) in texts"
              :key="item.id"
              :class="{ active: index == num }"
              @click="tab(item.id, index)"
              :index="item.index"
            >
              <a style="font-weight: bold" >
                {{ item.text }}
              </a>
            </li> -->
			<!-- <li
			id="li"
			  v-for="(item, index) in texts"
			  :key="item.id"
			  :class="{ active: index == num }"
			  @click="tab(item.id, index)"
			  :index="item.index"
			>
			  <a style="font-weight: bold" >
			    {{ item.text }}
			  </a>
			</li>
			<li
			id="li"
			  v-for="(item, index) in texts"
			  :key="item.id"
			  :class="{ active: index == num }"
			  @click="tab(item.id, index)"
			  :index="item.index"
			>
			  <a style="font-weight: bold" >
			    {{ item.text }}
			  </a>
			</li> -->
    <!--    </ul> -->
        </div>
		<!-- <div @click="showclick" style="cursor: pointer;">
			<span class="user_info" >
				<span class="font_span">
					{{userName}}
				</span>您好！
			</span>
			<div id="links" v-if="link" @click="handleCommands" style="width:120px;background-color: white;right:10px;padding: 10px;position: absolute;color:black;z-index: 999;top: 30px;cursor: pointer;">
					<i class="icon_logout"></i>	 退出登录 
			</div>
			<div id="links" v-if="link" @click="handleCommandss" style="width:120px;background-color: white;right:10px;padding: 10px;position: absolute;color:black;z-index: 999;top: 80px;cursor: pointer;">
					<i class="icon_password"></i>	 修改密码 
			</div>
		</div> -->
		<div class="button_block" v-viewButton>
		    <rs-dropdown trigger="click" @command="handleCommand"  class="user_info_block" @visible-change="changeClass">
		        <span class="user_info" :class="{cur:show}"><span class="font_span">{{userName}}</span> 您好！</span>
		        <rs-dropdown-menu slot="dropdown" v-if="!oaCode">
		            <rs-dropdown-item command="change"><i class="icon_password"></i>修改密码</rs-dropdown-item>
		            <rs-dropdown-item command="logout"><i class="icon_logout"></i>退出登录</rs-dropdown-item>
		        </rs-dropdown-menu>
		    </rs-dropdown>
		</div>
        <!-- <div
        >
          <span class="user_info"
            ><span @click="show" class="font_span">{{ userName }}</span> 您好！</span
          >
		  <div v-if="link" style="background-color: white;padding: 5px;position: absolute;z-index: 999;top: 30px;cursor: pointer;">
			 <i class="icon_logout"></i>退出登录 
		  </div> -->
          <!-- <rs-dropdown-menu slot="dropdown" v-if="!oaCode" > -->
            <!-- <rs-dropdown-item command="change"><i class="icon_password"></i>修改密码</rs-dropdown-item> -->
           <!-- <rs-dropdown-item command="logout"
              ><i class="icon_logout"></i>退出登录</rs-dropdown-item
            > -->
        <!--  </rs-dropdown-menu> -->
       <!-- </div> -->
      </div>
    </rs-header>
    <rs-container class="main-container" style="height: calc(100% - 52px)">
	<!-- 	<rs-aside> -->
			<menu-div
			   :isCollapse="isCollapse"
			   ref="menu"
			   @jumpUrl="jumpUrl"
			   @hasSy="hasSy"
			   @getMenuResource="getMenuResource"
			 ></menu-div>
		<!-- </rs-aside> -->
     
      <div v-if="nopower == true" class="nopower">
        <img src="../../assets/images/icon-no-auth.png" alt />
        <p class="no-auth-text">您暂时无法访问系统</p>
        <p class="no-auth-text-span">
          如需访问，请提交账号开通流程，如已提交流程，请联系IT客服处理
        </p>
      </div>
      <rs-main v-else style='overflow-y: scroll;'>
        <!-- <rs-tabs v-model="editableTabsValue" type="card"  @tab-remove="removeTab" class="main rs-container is-vertical" style="height:100%">
                    <rs-tab-pane
                        v-loading="item.loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="rs-icon-loading"
                        element-loading-background="rgba(249, 249, 249, 0.8)"
                        v-for="(item, index) in editableTabs"
                        :key="item.name"
                        :label="item.title"
                        :name="item.name"
                        :closable="item.closeable"
                        class="rs-main">
                        <iframe id="main_iframe" ref="mainIframe" :src="item.url"></iframe>
                    </rs-tab-pane>
                </rs-tabs> -->
        <div
          style="height: 100%; position: absolute; width: 100%"
          v-if="loadingFlagHome"
          v-loading="loadingFlagHome"
          element-loading-text="拼命加载中"
          element-loading-spinner="rs-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
        ></div>
      <!-- <iframe
		 @click='show'
          id="iframeHome"
          class="iframeHomeIndexArr"
          ref="mainIframe"
          :src="iframeUrl"
        ></iframe> -->
	<router-view></router-view>
        <!--</div>-->
      </rs-main>
    </rs-container>
    <change-password
      ref="ChangePassword"
      :showPassword="showPassword"
      @hidePassword="hidePassword"
    ></change-password>
<!-- 	<rs-dialog title='修改密码' width='30%' :visible.sync="dialogFormVisibless"  :modal-append-to-body="false">
		<rs-form :model="ruleForm" status-icon :rules="rules1" ref="ruleForm" class="demo-ruleForm">
			<rs-form-item label="新密码" :label-width="formLabelWidth" prop="pass">
				<rs-input type="password" placeholder="请输入密码" v-model="ruleForm.pass"
					show-password autocomplete="off"></rs-input> -->
				<!-- <rs-progress :percentage="passwordPercent" :format="passwordPercentFormat"></rs-progress> -->
		<!-- 	</rs-form-item>
			<rs-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth">
				<rs-input type="password" placeholder="请输入密码" show-password
					v-model="ruleForm.checkPass" autocomplete="off"></rs-input>
			</rs-form-item>
		</rs-form>
		<div slot="footer" class="dialog-footer">
			<rs-button @click="passcan">取 消</rs-button>
			<rs-button type="primary" @click="submitForm('ruleForm')">提交</rs-button>
			<rs-button @click="resetForm('ruleForm')">重置</rs-button>
		</div>
	</rs-dialog> -->
  </rs-container>
  
</template>

<script>
	   import { mapState,mapMutations } from 'vuex';
import Utils from "@/utils/utils";
import Http from "@/api/api";
import OaApi from "@/api/oa";
import MenuDiv from "@/components/leftMenu-index";
import changePassword from "../../components/password.vue";
import redirect from "@/webconfig";
import ImgApi from "@/api/imgSetter";
export default {
  name: "home",
  components: {
    MenuDiv,
    changePassword,
  },
  data() {
	  var validatePass = (rule, value, callback) => {
	  	const reg = /^(?=.*?[0-9a-zA-Z])(?=.*?[0-9a-zA-Z])[0-9a-zA-Z]{8,}$/; //mima123456
	  	//       if (value === '') {
	  	//         callback(new Error('请输入密码'));
	  	//       }else if(!reg.test(value)){
	  	// 	 callback(new Error('密码格式输入错误'));
	  	// } else {
	  	//         if (this.ruleForm.checkPass !== '') {
	  	//           this.$refs.ruleForm.validateField('checkPass');
	  	//         }
	  	//         callback();
	  	//       }
	  	if (value === '') {
	  		callback(new Error('请输入密码'));
	  	} else {
	  		//6-20位包含字符、数字和特殊字符
	  		var ls = 0;
	  		if (value !== '') {
	  			if (value.match(/([a-z])+/)) {
	  				ls++;
	  			}
	  			if (value.match(/([0-9])+/)) {
	  				ls++;
	  			}
	  			if (value.match(/([A-Z])+/)) {
	  				ls++;
	  			}
	  			if (value.match(/([\W])+/) && !value.match(/(![\u4E00-\u9FA5])+/)) {
	  				ls++;
	  			}
	  			if (value.length < 6 || value.length > 20) {
	  				callback(new Error('要求6-20位字符'));
	  				ls = 0;
	  			}
	  			if (value.match(/([\u4E00-\u9FA5])+/)) {
	  				callback(new Error('不能包含中文字符'));
	  				ls = 0;
	  			}
	  			switch (ls) {
	  				case 0:
	  					this.passwordPercent = 0;
	  					callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
	  					break;
	  				case 1:
	  					this.passwordPercent = 33;
	  					callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
	  					break;
	  				case 2:
	  					this.passwordPercent = 66;
	  					callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
	  					break;
	  				case 3:
	  				case 4:
	  					this.passwordPercent = 100;
	  					break;
	  				default:
	  					this.passwordPercent = 0;
	  					break;
	  			}
	  		}
	  		callback();
	  	}
	  };
	  var validatePass2 = (rule, value, callback) => {
	  	if (value === '') {
	  		callback(new Error('请再次输入密码'));
	  	} else if (value !== this.ruleForm.pass) {
	  		callback(new Error('两次输入密码不一致!'));
	  	} else {
	  		callback();
	  	}
	  };
    return {
		formLabelWidth: "120px",
		dialogFormVisibless:false,
		rules1: {
			pass: [{
				validator: validatePass,
				trigger: 'blur',
				required: true
			}],
			checkPass: [{
				validator: validatePass2,
				trigger: 'blur',
				required: true
			}]
		},
		ruleForm: {
			pass: '',
			checkPass: '',
		
		},
		 tags: [],
		activeIndex: "/index",
      num: 0,
      texts: [
        { id: 0, name: "index", text: "首页", href: "#",index:'/index', },
        { id: 1, name: "sys", text: "缴费中心", href: "#",index:'/renTal' },
        { id: 2, name: "cam", text: "用户中心", href: "#",index:'/myHome' },
      ],
      isLoding: true,
      show: false,
      dialogVisible: false,
      showPassword: false,
      showQuestion: false,
      UserLeftComplaint: 0,
      userName: "",
      shopName: "",
      editableTabsValue: "main",
      editableTabs: [],
      tabIndex: 1,
      NoticeImgData: "",
      fresh: false,
      maskFlag: false,
      iframeUrl: "/#/index",
      collapseFlag: false, // 菜单展开合并,
      loadingFlagHome: false,
      imgForm: {},
      oaCode: "", // 是否从oa进入
      nopower: false,
      isCollapse: false, // 菜单展开收起
      styID:'',
	  link:false,
	  lastTime: null, // 最后一次点击的时间
	       currentTime: null, // 当前点击的时间
	       timeOut: 1 * 60 * 1000, // 设置超时时间:10分钟
	       timeInterval: "",
    };
  },
 
  created(){
	   this.tags = this.stateTagsList;
	   console.log(localStorage.getItem('styid'))
	  this.activeIndex = this.$route.path;
	// document.getElementById('li').onclick=function(){
	// 	if(this.iframeUrl=='/#/renTal'){
	// 		this.tab()
	// 	}
	// }
	 console.log(this.$route.path)
	 console.log(this.$route.query.id)
	  // this.moveEvent()
	  // this.lastTime = new Date().getTime();
  },
  computed: {
              ...mapState(['stateTagsList'])
          },
  mounted(){
	  console.log(this.$route.query.id)
	 // document.onclick=function(){
	 // 		  document.getElementById('links').style.display='none'
	 // }
	 // window.addEventListener('click',()=>{
		//  this.link=false
	 // })
  },
  methods: {
	  ...mapMutations({
	                  close: 'mutationCloseTag'
	              }),
	              handleClose(tag, index) {
					  console.log(this.tags)
	                  if (this.tags.length === 1) { // 如果只有一个标签则不能关闭
	                      return
	                  }
	                  this.close(tag) // 删除当前tag
	                  if (this.$router.path === tag.resourceUrl) { // 如果关闭的标签不是当前路由的话，不做路由跳转
	                      return
	                  } else {
	                      if (index === (this.tags.length - 1)) { // 关闭最后一个标签,则路由跳转至最后一个
	                          this.$router.push(this.tags[index].resourceUrl)
	                      } else { // 路由跳转至下一个标签页
	                          if(index===0){
	                              this.$router.push(this.tags[0].resourceUrl)
	                          }else{
	                              this.$router.push(this.tags[index - 1].resourceUrl)
	                          }
	                      }
	                  }
	              },
	              // 点击tags具体标签
	              handleClick(tag) {
	                  this.$router.push(tag.resourceUrl)
	              },
	  handleSelect(key, keyPath) {
	        console.log(key, keyPath);
	      },
	 //  show(){
		// this.link=false  
	 //  },
	 // document.body.onclick(function(){
		//  this.link=false
	 // }),
	 //   clickDiv() {
	 //         if (this.timeInterval == "") {
	 //          // 5秒钟检测一次
	 //           this.timeInterval = setInterval(this.isTimeOut, 5000);
		// 	   console.log(111)
	 //         }
	 //         this.lastTime = new Date().getTime();
	 //       },
	 //       isTimeOut() {
	 //         this.currentTime = new Date().getTime(); // 当前时间
	 //         // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于规定的时间,例:10分钟
	 //         if (this.currentTime - this.lastTime > this.timeOut) {
	 //           //判断是否为登录状态,只有登录状态下才调用方法
	 //           if (sessionStorage.token) {
	 //             sessionStorage.clear();
	 //             clearInterval(this.timeInterval);
	 //             this.timeInterval = "";
	 //             this.$router.push({
	 //               name: "/paymentLogin",
	 //             });
	 //             //先返回首页,在给提示,可以根据具体需求调整
	 //             this.$alert("检测到您长时间未操作页面,请重新登录!", "温馨提示", {
	 //               confirmButtonText: "确定",
	 //               callback: (action) => {},
	 //             });
	 //           }
	 //         }
	 //       },
	 
	
	  showclick(){
		  if(this.link==false){
			  this.link=true  
		  }else{
			  this.link=false
		  }
		
	  },
    tab(id, val) {	
      this.num = val;
      this.bus.$emit("sendId", id);
      if(id==0){
		  // this.$router.push({path:'/index'})
        this.iframeUrl='/#/index'
      }else if(id==1){
        this.iframeUrl='/#/renTal'
      }else{
        this.iframeUrl='/#/MyHome'
      }
      console.log(id);
    },
    // 从oa跳转进来获取重定向信息
    getZjInfo() {
      OaApi.getZjInfo().then((res) => {
        this.$store.dispatch("setOaZjInfo", res.data.data);
      });
    },
    changeClass(e) {
      this.show = e;
    },
    changeMenu() {
      this.collapseFlag = !this.collapseFlag;
      this.$refs.menu.bindCollapse();
    },
    // 获取图片
    getImg() {
      ImgApi.findAllConfig({
        configType: "custom",
        pageNum: 1,
        pageSize: 99,
      }).then((res) => {
        res.data.data.list.forEach((item) => {
          this.imgForm[item.configType] = item.configValue;
        });
        Utils.setSession("imgInfo", this.imgForm);
        Utils.setLocalStorage("imgInfo", this.imgForm);
        this.$forceUpdate();
      });
    },
	//重置
	resetForm(formName) {
		this.$refs[formName].resetFields();
	},
	handleCommandss() {
	    this.dialogFormVisibless=true
	},
	submitForm(formName) {
		this.$refs[formName].validate((valid) => {
			if (valid) {
				let params = {
					id: this.passId,
					contactNumber: this.contactNumber,
					contactName: this.contactName,
					password:this.ruleForm.pass
				}
				API.unpdatePassword(params).then((res) => {
					if (res.data.code == 200) {
						console.log(res)
						this.$message({
							message: '修改密码成功,请重新登录',
							type: 'success'
						})
						this.dialogFormVisibless = false
						 this.$router.push("/paymentLogin");
					}
				});
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	},
	passcan() {
		this.ruleForm.pass='',
		this.ruleForm.checkPass=''
		this.dialogFormVisibless = false
			// this.getlist()
	},
	handleCommands() {
	
	    this.$confirm("确定退出吗", "提示", {
	      confirmButtonText: "退出",
	      cancelButtonText: "取消",
	      type: "warning",
	    })
	      .then(() => {
	        // Http.logout().then((res) => {
	        this.$router.push("/paymentLogin");
	
	        // Utils.delLocalStorage('userInfo')
	        // Utils.delLocalStorage('buttonResource')
	        // Utils.delSessionStorage('userInfo')
	        // Utils.delSessionStorage('leftMenuInit')
	        // })
	      })
	      .catch(() => {});
	},
    handleCommand(command) {
      if (command === "change") {
        this.showPassword = true;
        this.$refs.ChangePassword.init();
      } else if (command === "logout") {
        this.$confirm("确定退出吗", "提示", {
          confirmButtonText: "退出",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // Http.logout().then((res) => {
            this.$router.push("/paymentLogin");

            // Utils.delLocalStorage('userInfo')
            // Utils.delLocalStorage('buttonResource')
            // Utils.delSessionStorage('userInfo')
            // Utils.delSessionStorage('leftMenuInit')
            // })
          })
          .catch(() => {});
      }
    },
    handledrop(command) {
      // if(command === 'question'){
      //     this.showQuestion = true
      // } else if(command === 'help'){
      //     //postMessage.openTab('公告','/administration/#/administrationNoticeList')
      // }
    },
    hidePassword() {
      this.showPassword = false;
    },
    hideQuestion() {
      this.showQuestion = false;
    },
    jumpUrl(url, type) {
      console.log(url);
      let array = url.split("$");
      let Url = url;
	  console.log(array)
			// let Url = url.split('&')[1]
      array.forEach((item, index) => {
        if (index == 1) {
          Url = item;
        } else if (index > 1) {
          Url = Url + "&" + item;
        }
      });
      if (type == "http") {
        //直接跳外网，无需处理
        this.$refs.mainIframe.contentWindow.location.href = Url;
      } 
      // 组织管理&/#/organization

      //Url = Url.replace(/&/g, '&').replace(/"/g, '\"').replace(/</g, '<').replace(/>/g, '>')
      // this.iframeUrl = Url
      // this.$refs.mainIframe.contentWindow.location.href = window.location.href.split('/#/')[0] + Url

      // this.addTab(title,Url)
    },
    setUrl(url) {
      url = url
        .replace(/%2F/g, "/")
        .replace(/%23/g, "#")
        .replace(/%3D/g, "=")
        .replace(/%26/g, "&")
        .replace(/%3F/g, "?");
      this.$router.push({
        query: {
          link: url,
          hash: new Date().getTime(),
          code: this.oaCode,
        },
      });
    },
    hasSy() {
      //判断是否有首页
      this.addTab("首页", "/#/worktable");
    },
    // 判断菜单权限
    getMenuResource(data) {
      let { href, link } = this.$route.query;
      if (!data || !data.length) {
        this.nopower = true;
        return;
      }
      // if(!href && !link) {
      //     this.iframeUrl = data[0].resourceUrl || '/#/main'
      //     return
      // }
    },
    postMessageListener(e) {
      const vm = this;
      if (e.data.type === "showMask") {
        this.maskFlag = true;
      } else if (e.data.type === "hideMask") {
        this.maskFlag = false;
      } else if (e.data.type === "jumpUrl") {
        this.jumpUrl(e.data.url);
      }
      // else if(e.data.type === 'noLogin') {
      //     localStorage.removeItem('userInfo')
      //     if(!this.oaCode) {
      //         top.location.href = top.location.href.split('/#/')[0] + '/#/login'
      //     } else {
      //         top.location.href = `${redirect.baseUrl}/login`
      //     }
      // }
      else if (e.data.type === "openTab") {
        this.addTab(e.data.name, e.data.targetUrl, e.data.currentUrl);
      } else if (e.data.type === "alertDialog") {
        console.log(e.data.data);
      } else if (e.data.type == "closeOtherTab") {
        if (e.data.targetUrl) {
          vm.editableTabs.forEach((item) => {
            console.log(item);
            // if(item.url==decodeURI(e.data.currentUrl)){  //防止url中 中文转译
            if (item.url.split("?")[0] == e.data.targetUrl.split("?")[0]) {
              //防止url中 中文转译
              //关闭老页面
              vm.removeTab(item.name);
            }
          });
        }
      } else if (e.data.type === "closeTab") {
        // if(e.data.currentUrl){
        //     vm.editableTabs.forEach(item=>{
        //         // console.log(item);
        //         // if(item.url==decodeURI(e.data.currentUrl)){  //防止url中 中文转译
        //         if(item.url.split('?')[0]==e.data.currentUrl.split('?')[0]){  //防止url中 中文转译
        //             //关闭老页面
        //             vm.removeTab(item.name)
        //             //返回对应的页面
        //             const fromName = item.from.split('/#/')[1].split('?')[0]
        //             if(e.data.refresh){
        //                 vm.editableTabs.forEach( tab=>{
        //                     if(fromName == tab.name){
        //                         // console.log(branch);
        //                         if (branch && location.href.match(/\/(\w*?)(?=\/#\/)/) && location.href.match(/\/(\w*?)(?=\/#\/)/)[0] === branch[0]) {
        //                             branch = null
        //                         }
        //                         let url = branch?branch[0]+'/#/'+tab.url.split('/#/')[1]:'/#/'+tab.url.split('/#/')[1]
        //                         // let url ='/'+branch[0]+'/#/'+str.split('/#/')[1]
        //                         // console.log(url);
        //                         vm.addTab(tab.title,url,tab.from)
        //                     }
        //                 })
        //             }else{
        //                 this.editableTabsValue = fromName
        //             }

        //         }
        //     })

        // }else{
        this.$router.back(-1);
        //     this.removeTab(this.editableTabsValue)
        // }
      } else if (e.data.type == "hideLoading") {
        this.loadingFlagHome = false;
        // if(e.data.url){
        //     const url = window.location.href.split('/#/')[0]+e.data.url
        //     if(this.editableTabs&&this.editableTabs.length>0) {
        //         this.editableTabs.forEach(item=>{
        //             if(item.url.split('?')[0] == url){
        //                 item.loading = false
        //             }
        //         })
        //     }
        // }
      } else if (e.data.type == "showLoading") {
        this.loadingFlagHome = true;
        // if(e.data.url){
        //     const url = window.location.href.split('/#/')[0]+e.data.url
        //     this.editableTabs.forEach(item=>{
        //         if(item.url.split('?')[0] == url){
        //             item.loading = true
        //         }
        //     })
        // }
      }
    },
    addTab(title, url, from = "/#/main") {
      let flag = -1;
      let name;
      if (url) {
        if (url.split("/#/").length > 1) {
          name = url.split("/#/")[1].split("?")[0];
        } else {
          name = url.split("?")[0];
          url = "/#" + url;
        }
      } else {
        name = new Date().getTime();
        url = name;
      }

      this.editableTabs.forEach((v, i) => {
        if (v.name === name) {
          flag = i;
        }
      });
      this.setUrl(url);
      // if(flag === -1){
      //     this.editableTabs.push({
      //         title: title,
      //         name: name,
      //         url:window.location.href.split('/#/')[0] + url,
      //         closeable:true,
      //         from:from,
      //         loading:true,
      //     });
      // } else{
      //     // this.iframeUrl = window.location.href.split('/#/')[0] + url
      //     this.editableTabs[flag].url=window.location.href.split('/#/')[0] + url
      //     this.$refs.mainIframe[flag].contentWindow.location.href = window.location.href.split('/#/')[0] + url
      //     this.$refs.mainIframe[flag].contentWindow.location.reload()

      // }
      // this.editableTabsValue = name;
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
  },
  created() {
    top.window.$message = this.$message; // 消息框
    top.window.$confirmDialog = this.$confirmDialog; // 消息框
    top.window.$dialogManage = this.$dialogManage; // 消息框
    if (Utils.getLocalStorage("userInfo")) {
      Utils.setSession("userInfo", Utils.getLocalStorage("userInfo"));
    }
    this.$nextTick(() => {
      if (this.$route.query.href && this.$route.query.href != "undefined") {
        this.iframeUrl = `${window.location.href.split("/#/")[0]}${
          this.$route.query.href
        }`;
        // alert(this.iframeUrl)
      } else if (this.$route.query.link) {
        this.iframeUrl =
          window.location.href.split("/#/")[0] +
          this.$route.fullPath
            .split("?link=")[1]
            .split("&hash=")[0]
            .replace(/%2F/g, "/")
            .replace(/%23/g, "#")
            .replace(/%3D/g, "=")
            .replace(/%26/g, "&")
            .replace(/%3F/g, "?");
      }
    });
    let oaCode = Utils.getQueryString("code");
    this.oaCode = oaCode || "";
    // this.getZjInfo()
  },
  mounted() {
    window.addEventListener("message", this.postMessageListener);
    if (Utils.getSession("pay")) {
      this.userName = Utils.getSession("pay").userName;
      if (
        Utils.getSession("pay").mallVos &&
        Utils.getSession("pay").mallVos.length > 0
      ) {
        this.shopName = Utils.getSession("pay").mallVos[0].mallName;
      }
      // Http.findSysUserInfo({"loginNameOrMobile":Utils.getSession('userInfo').loginName,"companyCode":"10001","loginSource":"E_WEB","loginType":"PASSWORD"}).then(res => {
      //     if(res.data.code == 200){
      //         Utils.setSession('userInfo',res.data.data)
      //     }
      // })
    }
    let imgForm = Utils.getLocalStorage("imgInfo");
    if (imgForm) {
      this.imgForm = imgForm;
    } else {
      this.getImg();
    }
  },
  // beforeRouteEnter(to,from,next){
  //     let oaCode = Utils.getQueryString('code') || '';
  //     if(Utils.getLocalStorage('shopVo')){
  //         next()
  //     } else{
  //         if(!oaCode) {

  //             next('/payHome')
  //         } else {
  //             next(vm=>{
  //                 top.location.href = `${redirect.baseUrl}/payHome`

  //             next('/paymentLogin')
  //         } )
      
  // }
  // }
  // },
  // watch: {
  //   $route: {
  //     handler: function (val, oldVal) {
  //       // if(val == oldVal){
  //       //     this.$refs['mainIframe'].contentWindow.location.reload()
  //       // } else{
  //       let Url;
  //       if (val.fullPath.split("?link=").length > 0) {
  //         Url = val.fullPath.split("?link=")[1];
  //         Url = Url.split("&hash=")[0];
  //         if (Url.split("?").length > 1 || Url.split("%3F").length > 1) {
  //           Url = Url + "&hash=" + new Date().getTime();
  //         } else {
  //           Url = Url + "?hash=" + new Date().getTime();
  //         }
  //       }
  //       this.$refs.mainIframe.contentWindow.location.replace(
  //         Url.replace(/%2F/g, "/")
  //           .replace(/%23/g, "#")
  //           .replace(/%3D/g, "=")
  //           .replace(/%26/g, "&")
  //           .replace(/%3F/g, "?")
  //       );

  //       // this.iframeUrl = Url.replace(/%2F/g,"/").replace(/%23/g,"#").replace(/%3D/g,"=").replace(/%26/g,"&").replace(/%3F/g,"?")
  //       this.loadingFlagHome = true;
  //       setTimeout(() => {
  //         this.loadingFlagHome = false;
  //       }, 1000);
  //       //}
  //     },
  //     // 深度观察监听
  //     deep: true,
  //   },
  // },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.rs-aside{
	width: 100px;
}
.menuShouqi {
  cursor: pointer;
  margin-right: 4px;
  opacity: 0.9;
}
ul {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: 150px;
  // width: 100%;
}
li a {
  color: #a4acbc;
}
li {
  padding: 5px;
  text-align: center;
  width: 100px;
  margin-right: 10px;
}
.active {
  a {
    color: #ffffff;
  }

  border-bottom: 2px solid #3370ff;
}
  // .rs-menu {
  //   background-color: rgba(255, 255, 255, 0) !important;
  //   .rs-submenu__title:hover{
  //      background-color: rgba(20, 75, 255, 0.0) !important;
  //   }
  //   .menuItem {
  //     font-size: 18px;
  //     min-width: 140px;
  //     text-align: center;
  //   }
  //   .rs-menu-item:hover {
  //     background-color: rgba(255, 255, 255, 0) !important;
  //     color: #ffffff !important;
  //     font-size: 20px;
  //   }

  //   .rs-menu-item.is-active {
  //     background: rgba(255, 255, 255, 0) !important;
  //     color: #ffffff !important;
  //     font-size: 24px;
  //   }
  //   .rs-submenu__title.is-active {
  //     background: rgba(255, 255, 255, 0) !important;
  //     font-size: 24px;
  //   }
  // }
  // .rs-menu--horizontal > .el-menu-item.is-active {
  //   border-bottom: 4px solid #409eff;
  // }
  // /deep/ .rs-menu.rs-menu--horizontal {
  //   border: none;
  // }
</style>

